<template>
  <div class="NewHot">
    <div class="new_hot_cont">
      <ul>
        <li v-for="item in hotconnum" :key="item.name">
          <p class="num flex">
            <vns :start="0" :end="Number(item.numb)" :times="50" :speed="20"/><i>+</i>
          </p>
          <!-- <span>{{item.numb}}</span>+ -->
          <p>{{item.title}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {gethomepc} from "@/config/api.js";
 import vns from 'vue-number-scroll';
export default {
  name: "NewHot",
  components:{
    vns
  },
  data() {
    return {
      numb:123,
      hotconnum: [
        {
          numb: null,
          title: "服务客户（家）"
        },
        { numb: null, title: "曝光量（次）" },
        {
          numb: null,
          title: "人）"
        }
      ]
    };
  },
  methods: {
    getInfopo() {
      this.$post(gethomepc, {
        key: "pc_home_page"
      })
        .then(res => {
          let data = res.data;
          let statistics = JSON.parse(data).statistics;
          for (let i = 0; i < this.hotconnum.length; i++) {
            this.hotconnum[i].numb = statistics[i].num;
            this.hotconnum[i].title = statistics[i].name;
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    },
  },
  mounted() {
    this.getInfopo();
  }
};
</script>

<style>
.NewHot .new_hot_cont {
  height: 450px;
  width: 1200px;
  margin: 0 auto;
}
.NewHot .new_hot_cont ul {
  height: 450px;
  width: 1200px;
  display: flex;
  flex: 1;
  justify-content: space-around;
}
.NewHot .new_hot_cont ul li {
  margin-top: 160px;
  height: 91px;
  font-size: 30px;
  font-weight: bold;
  line-height: 34px;
  color: rgba(54, 55, 61, 1);
  opacity: 1;
}
.NewHot .new_hot_cont ul li span {
  display: inline-block;
  font-size: 60px;
  margin-bottom: 10px;
  font-weight: bold;
  line-height: 60px;
  color: rgba(54, 55, 61, 1);
}
.NewHot .new_hot_cont ul li p {
  text-align: center;
  font-size: 14px;
  font-weight: normal;
  line-height: 18px;
  color: #666;
  opacity: 1;
}
.NewHot .new_hot_cont .num{align-items:flex-end}
.NewHot .new_hot_cont .num i{font-size: 30px;line-height: 52px;}
</style>
